import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full bg-white border-b border-gray-100 shadow-sm sticky top-0 z-50" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col justify-center border-r border-gray-50 min-w-max lg:min-w-[1/4]"
}
const _hoisted_3 = {
  key: 1,
  class: "flex-1 grid grid-cols-3 items-stretch bg-gray-100 gap-px overflow-x-auto"
}
const _hoisted_4 = { class: "flex w-full items-center space-x-2 lg:space-x-4" }
const _hoisted_5 = {
  key: 0,
  class: "text-xs lg:text-sm font-bold"
}
const _hoisted_6 = {
  key: 1,
  class: "text-xs lg:text-sm font-bold"
}
const _hoisted_7 = { class: "flex flex-col min-w-0 grow" }
const _hoisted_8 = {
  key: 0,
  class: "hidden sm:inline-block"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 0,
  class: "hidden lg:block ml-4 my-auto"
}
const _hoisted_13 = {
  key: 0,
  class: "relative w-16 h-16 rounded-full overflow-hidden flex items-center justify-center border border-gray-200"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  class: "hidden lg:block ml-4 my-auto items-center justify-center"
}
const _hoisted_17 = { class: "relative w-16 h-16 rounded-full overflow-hidden flex items-center justify-center p-1" }
const _hoisted_18 = { class: "flex w-full items-center space-x-2 lg:space-x-4 pl-4" }
const _hoisted_19 = {
  key: 0,
  class: "text-xs lg:text-sm font-bold"
}
const _hoisted_20 = {
  key: 1,
  class: "text-xs lg:text-sm font-bold"
}
const _hoisted_21 = { class: "flex flex-col min-w-0 grow" }
const _hoisted_22 = {
  key: 0,
  class: "hidden sm:inline-block"
}
const _hoisted_23 = {
  key: 0,
  class: "hidden sm:inline-block"
}
const _hoisted_24 = ["href"]
const _hoisted_25 = {
  key: 0,
  class: "text-red-500 font-bold"
}
const _hoisted_26 = ["href"]
const _hoisted_27 = {
  key: 1,
  class: "text-[8px] lg:text-[10px] font-medium flex items-center space-x-2"
}
const _hoisted_28 = ["href"]
const _hoisted_29 = {
  key: 0,
  class: "hidden lg:block ml-4 my-auto"
}
const _hoisted_30 = { class: "relative w-16 h-16 rounded-full overflow-hidden flex items-center justify-center border border-gray-200" }
const _hoisted_31 = {
  key: 1,
  class: "hidden lg:block ml-4 my-auto items-center justify-center"
}
const _hoisted_32 = { class: "relative w-16 h-16 rounded-full overflow-hidden flex items-center justify-center p-4" }
const _hoisted_33 = { class: "flex w-full justify-between items-center space-x-2 lg:space-x-4 pl-4" }
const _hoisted_34 = {
  key: 0,
  class: "text-xs lg:text-sm font-bold"
}
const _hoisted_35 = {
  key: 1,
  class: "text-xs lg:text-sm font-bold"
}
const _hoisted_36 = { class: "flex flex-col min-w-0 grow" }

import {computed, onMounted, ref, useSlots, watch} from "vue";
import {useStore} from "vuex";
import {Sessions} from "@/assets/ts/sessions";
import {SetWidget} from "@/assets/ts/stepWidget";
import DiamondImage from "@/components/diamonds/diamondImage.vue";
import {Diamond} from "@/store/modules/diamonds";
import DiamondRingIcon from "@/components/elements/diamondRingIcon.vue";
import DiamondIcon from "@/components/elements/diamondIcon.vue";
import NecklaceDiamondIcon from "@/components/elements/necklaceDiamondIcon.vue";

type stateStepType = {
  active: boolean,
  completed: boolean,
  view: string
  change: string
  image: boolean

}

type stateType = {
  step1: stateStepType,
  step2: stateStepType,
  step3: stateStepType
}


export default /*@__PURE__*/_defineComponent({
  __name: 'stepWidget',
  props: {
  show: {
    type: Boolean,
    default: false
  },
  catalogId: {
    type: String,
    default: ""
  }
},
  emits: ['certificatedDiamond'],
  setup(__props, { emit: __emit }) {

/**
 * State management
 *
 * page = catalog
 * step 1 = active
 * step 1 = not completed
 * link of step 1 = catalog + diamond id if diamond is is set
 * image step 1 = setting icon (placeholder)
 *
 * step 2 = not active
 * step 2 = if diamond id is set, completed else not completed
 * link of step 2 = diamond search if no diamond id is set else diamond details page
 * image step 2 = if diamond id is set, diamond image else diamond placeholder
 *
 * step 3 = not active
 * step 3 = not completed
 * link of step 3 = no link
 * image step 3 = step 3 has no image
 *
 * page = diamond
 * step 1 = not active
 * step 1 = completed if conf session id is set else not completed
 * link of step 1 = catalog + diamond id if diamond id is set else only catalog
 * image step 1 = if conf session id is set, item image else setting icon placeholder
 *
 * step 2 = active
 * step 2 = completed if conf session id is set else not completed
 * link of step 2 = diamond search + conf session id if conf session id is set else only diamond search
 * image step 2 = diamond placeholder
 *
 * step 3 = not active
 * step 3 = not completed
 * link of step 3 = no link
 * image step 3 = step 3 has no image
 *
 * page = conf
 * step 1 = not active
 * step 1 = completed
 * link of step 1 = catalog + diamond id
 * image step 1 = conf session item image
 *
 * step 2 = not active
 * step 2 = completed
 * link of step 2 = diamond id in diamond details page + conf session id
 * image step 2 = diamond image
 *
 * step 3 = active
 * step 3 = completed
 * link of step 3 = conf + conf session id
 * image step 3 = step 3 has no image
 *
 */
const store = useStore();
const slots = useSlots();

const sessionsApi = new Sessions();
const setWidgetApi = new SetWidget();

const emit = __emit;

const props = __props;

const session = computed(() => store.getters["session/get"]);
const sessionData = ref(session.value)

const confSession = computed(() => {
  return setWidgetApi.getConfSession();
});

const itemType = computed(() => {
  if (props.catalogId.includes('engagement_ring')) return 'ring';
  if (props.catalogId.includes('necklace')) return 'necklace';
  if (sessionData.value?.items?.[0]) {
    if (sessionData.value.items[0].facts.item_type === 'engagement_ring') return 'ring';
    if (sessionData.value.items[0].facts.item_type === 'necklace') return 'necklace';
  }
  return "default"
})

const state = ref({
  step1: {
    active: false,
    completed: false,
    view: '',
    change: '',
    image: false
  },
  step2: {
    active: false,
    completed: false,
    view: '',
    change: '',
    image: false
  },
  step3: {
    active: false,
    completed: false,
    view: '',
    change: '',
    image: false
  }
} as stateType)

const stateModeActive = ref(true)
watch(() => sessionData.value?.items?.[0]?.facts?.biggest_stone, (newVal) => {
  if (typeof newVal === 'undefined') {
    stateModeActive.value = true
  } else {
    stateModeActive.value = newVal >= 0.3
  }
}, {immediate: true})

onMounted(() => {
  if (confSession.value && session.value?.session_id !== confSession.value) {
    sessionsApi.getSimple(confSession.value).then((rawSessionData: any) => {
      sessionData.value = rawSessionData;
      if (sessionData.value?.items?.[0]?.facts?.certificated_diamond) {
        emit('certificatedDiamond', sessionData.value.items[0].facts.certificated_diamond);
      }
    });
  } else {
    if (session.value?.items?.[0]?.facts?.certificated_diamond) {
      emit('certificatedDiamond', session.value.items[0].facts.certificated_diamond);
    }
  }

  setState()
  store.dispatch('diamonds/fetchDiamond', setWidgetApi.getDiamondId())
});

watch(session, (newVal) => {
  sessionData.value = newVal;
  setState();
}, {deep: true})

/**
 * item and diamond data
 */

const itemData = computed(() => {
  return sessionData.value?.items?.[0] || null;
})

const diamondData = computed<Diamond | null>(() => store.getters['diamonds/getDiamondById'](setWidgetApi.getDiamondId()))


/**
 * state management
 */

const isDiamondIdSet = computed(() => {
  return diamondItem.value !== "" && diamondItem.value !== null;
});

const getPage = (): string => {
  const path = document.location.href;
  const hash = document.location.hash;

  if (path.includes('catalog') || (hash.includes('conf/') && !isDiamondIdSet.value)) {
    return "catalog";
  } else if (path.includes('diamonds')) {
    return "diamond";
  } else if (hash.includes('conf/') && isDiamondIdSet.value) {
    return "conf";
  }

  return "";
}

const setState = () => {
  setActiveStep()
  setCompletedStep()
}

const setActiveStep = () => {
  const page = getPage();

  if (page === 'catalog') {
    state.value.step1.active = true
    state.value.step2.active = false
    state.value.step3.active = false
  } else if (page === 'diamond') {
    state.value.step1.active = false
    state.value.step2.active = true
    state.value.step3.active = false
  } else if (page === 'conf') {
    state.value.step1.active = false
    state.value.step2.active = false
    state.value.step3.active = true
  }
}

const setCompletedStep = () => {
  const confSession = setWidgetApi.getConfSession();
  const diamondItem = itemData.value?.facts.certificated_diamond.check ? itemData.value?.facts.certificated_diamond.certificate : setWidgetApi.getDiamondId();

  state.value.step1.completed = confSession !== null;
  if (state.value.step1.completed) {
    state.value.step1.change = setWidgetApi.createPath('catalog', diamondItem);
    state.value.step1.view = setWidgetApi.createPath('conf');
    state.value.step1.image = true
  } else {
    state.value.step1.view = ""
    state.value.step1.change = ""
  }

  state.value.step2.completed = (confSession === null && diamondItem !== null) || (confSession !== null && diamondItem !== null);
  if (state.value.step2.completed) {
    state.value.step2.view = setWidgetApi.createPath('diamond', diamondItem);
    state.value.step2.change = setWidgetApi.createPath('diamondSearch');
    state.value.step2.image = true
  } else {
    state.value.step2.view = ""
    state.value.step2.change = ""
    state.value.step2.image = false
  }

  state.value.step3.completed = confSession !== null && itemData.value?.facts.certificated_diamond.check && isDiamondAvailable.value;
}

const isDiamondAvailable = computed(() => {
  return typeof itemData.value?.facts.certificated_diamond == "undefined" || itemData.value?.facts.certificated_diamond.available;
});

const diamondItem = computed(() => {
  const idx = 0
  if (session.value?.items && session.value?.items[idx]?.facts.certificated_diamond.check) {
    return session.value?.items[idx].facts.certificated_diamond.certificate
  } else if (setWidgetApi.getDiamondId() !== "") {
    return setWidgetApi.getDiamondId()
  }
  return ""
});

const formMap: Record<string, string> = {
  'ROUND': 'BR',
  'OVAL': 'OV',
  'EMERALD': 'EM',
  'PEAR': 'PE',
  'PRINCESS': 'PR',
  'RADIANT': 'RA',
  'HEART': 'HE',
  'MARQUISE': 'MA',
  'CUSHION': 'CU'
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["max-w-screen-4xl mx-auto flex items-stretch overflow-hidden", {
      'h-16 lg:h-20': !_unref(slots).default,
      'h-16 lg:h-24': _unref(slots).default
    }])
    }, [
      (_unref(slots).default)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        : _createCommentVNode("", true),
      (__props.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex items-center justify-center px-2 lg:px-6 relative group transition-all duration-300 step-container", {'active': state.value.step1.active, 'completed': state.value.step1.completed}])
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-7 h-7 lg:w-9 lg:h-9 rounded-full flex items-center justify-center border-2 transition-all duration-300", [state.value.step1.active ? 'border-white bg-white text-black' : (state.value.step1.completed ? 'border-brand-main text-brand-main' : 'border-gray-100 text-gray-300 group-hover:border-gray-200')]])
                }, [
                  (state.value.step1.completed)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "✓"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, "1"))
                ], 2),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["text-[9px] lg:text-[11px] font-bold uppercase tracking-wider truncate transition-colors", state.value.step1.active ? 'text-black font-bold' : 'text-gray-400 group-hover:text-gray-600'])
                  }, [
                    (state.value.step1.completed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('components.stepWidget.setting.' + itemType.value)) + " ", 1),
                          (sessionData.value?.items?.[0]?.price?.parts?.item)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                (sessionData.value.items[0].price.parts.stones == 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('components.stepWidget.including_diamond')), 1)
                                    ], 64))
                                  : (typeof sessionData.value.items[0].price.parts?.shoulder_stones !== 'undefined' && sessionData.value.items[0].price.parts?.shoulder_stones != 0)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('components.stepWidget.including_shoulder_stones')), 1)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                (typeof sessionData.value.items[0].price.parts?.shoulder_stones !== 'undefined' && sessionData.value.items[0].price.parts?.shoulder_stones >= 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _createTextVNode(" - " + _toDisplayString(_ctx.$n(sessionData.value.items[0].price.parts.item + sessionData.value.items[0].price.parts?.shoulder_stones, 'currency')), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _createTextVNode(" - " + _toDisplayString(_ctx.$n(sessionData.value.items[0].price.parts.item, 'currency')), 1)
                                    ], 64))
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('components.stepWidget.setting.' + itemType.value)), 1)
                        ], 64))
                  ], 2),
                  (state.value.step1.view || state.value.step1.change)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["text-[8px] lg:text-[10px] font-medium truncate flex flex-col sm:flex-row sm:items-center space-x-2", state.value.step1.active ? 'text-black' : 'text-brand-main'])
                      }, [
                        (state.value.step1.change)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: state.value.step1.change,
                              class: "hover:underline uppercase"
                            }, _toDisplayString(_ctx.$t('components.stepWidget.change')), 9, _hoisted_9))
                          : _createCommentVNode("", true),
                        (state.value.step1.view)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: state.value.step1.view,
                              class: "hover:underline uppercase"
                            }, _toDisplayString(_ctx.$t('components.stepWidget.view')), 9, _hoisted_10))
                          : _createCommentVNode("", true)
                      ], 2))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: _unref(setWidgetApi).createPath('catalog', _unref(setWidgetApi).getDiamondId()),
                        class: _normalizeClass(["text-[8px] lg:text-[10px] font-medium truncate hidden sm:block", state.value.step1.active ? 'text-black' : 'text-gray-400'])
                      }, _toDisplayString(_ctx.$t('components.stepWidget.browse_settings')), 11, _hoisted_11))
                ]),
                (state.value.step1.image)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (itemData.value?.image)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (itemData.value.image.filename_layer)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: itemData.value.image.filename_layer,
                                  class: "absolute insert-0 w-auto h-full aspect-square object-cover",
                                  alt: "Setting image"
                                }, null, 8, _hoisted_14))
                              : _createCommentVNode("", true),
                            _createElementVNode("img", {
                              src: itemData.value.image.filename,
                              class: "w-auto h-full aspect-square object-cover",
                              alt: "Setting image"
                            }, null, 8, _hoisted_15)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        (itemType.value == 'necklace')
                          ? (_openBlock(), _createBlock(NecklaceDiamondIcon, { key: 0 }))
                          : (_openBlock(), _createBlock(DiamondRingIcon, { key: 1 }))
                      ])
                    ]))
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["flex items-center justify-center px-2 lg:px-6 relative group transition-all duration-300 step-container", {'active': state.value.step2.active, 'completed': state.value.step2.completed}])
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-7 h-7 lg:w-9 lg:h-9 rounded-full flex items-center justify-center border-2 transition-all duration-300 shrink-0", [state.value.step2.active ? 'border-white bg-white text-black' : (state.value.step2.completed ? 'border-brand-main text-brand-main' : 'border-gray-100 text-gray-300 group-hover:border-gray-200')]])
                }, [
                  (state.value.step2.completed )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "✓"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_20, "2"))
                ], 2),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["text-[9px] lg:text-[11px] font-bold uppercase tracking-wider truncate transition-colors", state.value.step2.active ? 'text-black font-bold' : 'text-gray-400 group-hover:text-gray-600'])
                  }, [
                    (state.value.step2.completed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('components.stepWidget.diamond')) + " ", 1),
                          (diamondData.value?.price)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, " - " + _toDisplayString(_ctx.$n(diamondData.value?.price, 'currency')), 1))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (sessionData.value?.items?.[0]?.price?.parts?.stones)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, " - " + _toDisplayString(_ctx.$n(sessionData.value.items[0].price.parts.stones, 'currency')), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('components.stepWidget.choose_diamond')), 1)
                        ], 64))
                  ], 2),
                  (state.value.step2.completed)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["text-[8px] lg:text-[10px] font-medium flex flex-col sm:flex-row sm:items-center space-x-2", state.value.step2.active ? 'text-black' : 'text-brand-main'])
                      }, [
                        _createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                          href: state.value.step2.change,
                          class: "hover:underline uppercase"
                        }, _toDisplayString(_ctx.$t('components.stepWidget.change')), 9, _hoisted_24),
                        (!isDiamondAvailable.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('components.stepWidget.diamondNotAvailable')), 1))
                          : (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                              href: state.value.step2.view,
                              class: "hover:underline uppercase"
                            }, _toDisplayString(_ctx.$t('components.stepWidget.view')), 9, _hoisted_26))
                      ], 2))
                    : (!stateModeActive.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('components.stepWidget.min_diamond_size')), 1))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 2,
                          href: _unref(setWidgetApi).createPath('diamondSearch'),
                          class: _normalizeClass(["text-[8px] lg:text-[10px] font-medium truncate hidden sm:block", state.value.step2.active ? 'text-black' : 'text-gray-400'])
                        }, _toDisplayString(_ctx.$t('components.stepWidget.browse_diamonds')), 11, _hoisted_28))
                ]),
                (state.value.step2.image)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(DiamondImage, {
                          diamond: {form: formMap[sessionData.value.items[0]?.facts.certificated_diamond.current.form] || diamondData.value?.form || 'BR'},
                          alert: false
                        }, null, 8, ["diamond"])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(DiamondIcon)
                      ])
                    ]))
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["flex items-center justify-center px-2 lg:px-6 relative cursor-pointer group transition-all duration-300 step-container", {'active': state.value.step3.active, 'completed': state.value.step3.completed}])
            }, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-7 h-7 lg:w-9 lg:h-9 rounded-full flex items-center justify-center border-2 transition-all duration-300 shrink-0", [state.value.step3.active ? 'border-white bg-white text-black' : (state.value.step3.completed ? 'border-brand-main text-brand-main' : 'border-gray-100 text-gray-300 group-hover:border-gray-200')]])
                }, [
                  (state.value.step3.completed)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, "✓"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_35, "3"))
                ], 2),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["text-[9px] lg:text-[11px] font-bold uppercase tracking-wider transition-colors", state.value.step3.active ? 'text-black font-bold' : 'text-gray-400 group-hover:text-gray-600'])
                  }, _toDisplayString(_ctx.$t('components.stepWidget.complete_ring.' + itemType.value)), 3),
                  _createElementVNode("span", {
                    class: _normalizeClass(["text-[8px] lg:text-[10px] font-medium truncate hidden sm:block", state.value.step3.active ? 'text-black' : 'text-gray-400'])
                  }, _toDisplayString(_ctx.$t('components.stepWidget.select_ring_size.' + itemType.value)), 3)
                ])
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})